import ApplicationSerializer from '@square/dashboard-data/serializers/application';
import { v4 as uuid } from 'uuid';
export default ApplicationSerializer.extend({
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    // V2 format: seller_display_rates array (explicit array check handles null case)
    if (Array.isArray(payload.seller_display_rates)) {
      return this.normalizeSellerDisplayRatesResponse(store, primaryModelClass, payload, id, requestType);
    }

    // V1 format (or V2 fallback): processing_fees_collection array
    if (Array.isArray(payload.processing_fees_collection)) {
      // eslint-disable-next-line no-param-reassign
      payload = payload.processing_fees_collection.map(processingFee => {
        // eslint-disable-next-line no-param-reassign
        processingFee.id = uuid();
        return processingFee;
      });
      return this._super(store, primaryModelClass, payload, id, requestType);
    }

    // Handle unexpected response format gracefully (follows codebase pattern)
    // Log for debugging but don't crash - return empty record
    // eslint-disable-next-line no-console
    console.warn('[processing-fees] Unexpected response format: expected seller_display_rates or processing_fees_collection', payload);
    return this._super(store, primaryModelClass, [{
      id: uuid()
    }], id, requestType);
  },
  /**
   * Normalize V2 seller_display_rates response format.
   *
   * Input (V2 API response):
   * {
   *   "seller_display_rates": [
   *     {
   *       "headline_rate_name": 1,  // HeadlineFeeRateName enum value (may be string or number)
   *       "fee_rate": {
   *         "fee_rate_id": "RATE_ID",
   *         "variable_basis_points": 260,
   *         "fixed_cents": 10,
   *         "constraints": [...]
   *       }
   *     }
   *   ]
   * }
   *
   * Output (normalized payload passed to JSONSerializer):
   * {
   *   "id": "<uuid>",
   *   "seller_display_rates": [
   *     {
   *       "headline_rate_name": 1,  // Number for direct HeadlineFeeRateName enum comparison
   *       "fee_rate_id": "RATE_ID",
   *       "variable_basis_points": 260,
   *       "fixed_cents": 10,
   *       "constraints": [...]
   *     }
   *   ]
   * }
   * ember-data-model-fragments normalizes each fragment item through the fragment's
   * serializer (ApplicationSerializer), which converts snake_case keys to camelCase.
   */
  normalizeSellerDisplayRatesResponse(store, primaryModelClass, payload, id, requestType) {
    // Flatten each seller_display_rate
    // Use snake_case keys - ember-data-model-fragments normalizes each fragment item
    // through the fragment's serializer, which uses ApplicationSerializer.keyForAttribute
    // (returns underscore()) to map payload keys to camelCase attribute names
    const normalizedRates = payload.seller_display_rates.map(rate => {
      return {
        // Convert to number for direct comparison with HeadlineFeeRateName enum values
        headline_rate_name: Number(rate.headline_rate_name),
        fee_rate_id: rate.fee_rate?.fee_rate_id,
        variable_basis_points: rate.fee_rate?.variable_basis_points,
        fixed_cents: rate.fee_rate?.fixed_cents,
        constraints: rate.fee_rate?.constraints || []
      };
    });

    // Create a single processing-fees record with the seller_display_rates array
    // Use snake_case key for top-level so ApplicationSerializer converts to camelCase
    const normalizedPayload = [{
      id: uuid(),
      seller_display_rates: normalizedRates
    }];
    return this._super(store, primaryModelClass, normalizedPayload, id, requestType);
  }
});